// extracted by mini-css-extract-plugin
export default {"content":"Main_content__kYU9n","addNewButtonContainer":"Main_addNewButtonContainer__o7pGP","addNewButton":"Main_addNewButton__qslX1","loadingWrapper":"Main_loadingWrapper__Of35Q"};